export default __webpack_public_path__ + "static/media/wide.8e72e2bb.png";